import { lazy } from 'react';

const ManageUserPages = lazy(() => import('../../pages/user'));
const ManageBookingPages = lazy(() => import('../../pages/booking'));
const RegisterWarrantyPages = lazy(() => import('../../pages/register-warranty'));
const ManageSerialPage = lazy(() => import('../../pages/manage-serial'));
const PackagePage = lazy(() => import('../../pages/manage-serial'));

export const MyNav = [
  {
    icon: 'pe-7s-bookmarks',
    label: 'register-warranty',
    to: '#/register-warranty',
    path: '/register-warranty',
    component: RegisterWarrantyPages
  },
  {
    icon: 'pe-7s-bookmarks',
    label: 'register-warranty',
    to: '#/manage-serial',
    path: '/manage-serial',
    component: ManageSerialPage
  },
  {
    icon: 'pe-7s-bookmarks',
    label: 'Bookings',
    to: '#/bookings',
    path: '/bookings',
    component: ManageBookingPages
  },
  {
    icon: 'pe-7s-box1',
    label: 'Packages',
    to: '#/packages',
    path: '/packages',
    roles: [600],
    component: PackagePage
  },
  {
    icon: 'pe-7s-users',
    label: 'Users',
    to: '#/users',
    path: '/users',
    roles: [600],
    component: ManageUserPages
  },
];
